/* eslint-disable */
/* global config */
import Vue from 'vue';
import session from './session';
import Mediator from '../Mediator';
import moment from 'moment-timezone';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import axios from 'axios';
import {
    ObjectID
} from 'bson';

export const bus = new Vue();

export function isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

export function isGridHide(property) {
    if (!property) return true;
    if (property['x-ui']) {
        if (property['x-ui'].grid) {
            return property['x-ui'].grid.hide === true ? true : false;
        }
    }
    return true;
}

export function getGridWidth(property) {
    if (!property) return '0';
    if (property['x-ui']) {
        if (property['x-ui'].grid) {
            if (typeof property['x-ui'].grid.width !== 'undefined') {
                return property['x-ui'].grid.width === '*' ? '100%' : property['x-ui'].grid.width;
            }
        }
    }
    return '0';
}

export function getGridColAlign(property) {
    if (!property) return 'left';
    let type = getFormType(property);
    if (type === 'currency' || type === 'number' || type === 'integer') {
        return 'right';
    }
    if (property['x-ui']) {
        if (property['x-ui'].grid) {
            if (typeof property['x-ui'].grid.align !== 'undefined') {
                return property['x-ui'].grid.align;
            }
        }
    }
    return 'left';
}

export function getGridLabel(property) {
    if (!property) return '';
    if (property['x-ui']) {
        if (property['x-ui'].grid) {
            return property['x-ui'].grid.label ? property['x-ui'].grid.label : property.description;
        }
    }
    return property.description;
}

export function getDefaultGridColumnSettings(prop, property = false) {
    let settings = {
        text: property ? property.description : 'no description',
        align: getGridColAlign(property),
        sortable: true,
        id: prop,
        hide: isGridHide(property),
        width: getGridWidth(property),
        label: getGridLabel(property) !== '' ? getGridLabel(property) : prop,
        $collection: getFieldCollectionSettings(property),
    };
    return settings;
}

export function setGriHeaders(component, properties) {

    if (!component.hideFields) component.hideFields = [];
    if (!component.hideSubFields) component.hideSubFields = {};

    for (let prop in properties) {
        if (properties.hasOwnProperty(prop)) {
            let property = properties[prop];
            let settings = getDefaultGridColumnSettings(prop, property);

            if (property.type === 'boolean') {
                component.forms.crud.user_values[prop] = false;
                component.forms.crud.defaultItem[prop] = false;
                component.form_search.user_values[prop] = false;

            } else if (property.type === 'date') {
                let d = null;
                component.forms.crud.user_values[prop] = d;
                component.forms.crud.defaultItem[prop] = d;
                component.form_search.user_values[prop] = d;
                component.form_search.user_values[prop + '_2'] = d;
            } else if (property.type === 'base64') {
                let d = null; // '/static/avatar.png';
                component.forms.crud.user_values[prop] = d;
                component.forms.crud.defaultItem[prop] = d;
                // component.form_search.user_values[prop] = d;
                // component.form_search.user_values[prop + '_2'] = d;
            } else if (property.type === 'date-time') {
                let d = null;
                component.forms.crud.user_values[prop] = d;
                component.forms.crud.defaultItem[prop] = d;
                component.form_search.user_values[prop] = d;
                component.form_search.user_values[prop + '_2'] = d;
            } else if (property.type === 'number') {
                component.forms.crud.user_values[prop] = '';
                component.forms.crud.defaultItem[prop] = '';
                component.form_search.user_values[prop] = '';
                component.form_search.user_values[prop + '_2'] = '';
            } else if (property.type === 'array') {
                component.forms.crud.user_values[prop] = [];
                component.forms.crud.defaultItem[prop] = [];
                component.form_search.user_values[prop] = [];
            } else {
                component.forms.crud.user_values[prop] = '';
                component.forms.crud.defaultItem[prop] = '';
                component.form_search.user_values[prop] = '';
            }
            component.forms.crud.newItem[prop] = '';
            component.form_search.operators[prop] = 'eq';


            component.headers.push(settings);
        }
    }
}

export function mountDataForGrid(_headers, data = []) {
    // const data = JSON.parse(JSON.stringify(_data));
    const headers = JSON.parse(JSON.stringify(_headers));
    let hide = headers.filter(column => {
        return column.hide === true
    });
    let notHide = headers.filter(column => {
        return column.hide !== true
    });
    // console.log('mountDataForGrid --------------->', data);
    // console.log('headers', headers);
    let records = !data.map ? [] : data.map(doc => {

        for (let x = 0; x < hide.length; x++) {
            let column = hide[x];
            delete doc[column.id];
        }

        for (let x = 0; x < notHide.length; x++) {
            let column = notHide[x];
            // console.log('column', column);
            // flatpickr.formatDate(new Date(value), 'F j, Y')
            doc[column.id] = doc[column.id] || '';
        }

        // format record
        return doc;
    });
    // console.log('records', records);
    return records;
}


export async function mountLabelsForGrid(subFieldDefinition, _headers = [], data = []) {
    // const data = JSON.parse(JSON.stringify(_data));
    const headers = JSON.parse(JSON.stringify(_headers));
    let hide = headers.filter(column => {
        return column.hide === true
    });
    let notHide = headers.filter(column => {
        return column.hide !== true
    });
    let nDocs = [];
    // console.log('mountDataForGrid --------------->');
    // console.log('headers', headers);
    for (let y = 0; y < data.length; y++) {
        let doc = data[y];
        for (let x = 0; x < hide.length; x++) {
            let column = hide[x];
            delete doc[column.id];
        }

        for (let x = 0; x < notHide.length; x++) {
            let column = notHide[x];
            // console.log('column', column);
            let definition = subFieldDefinition.properties[column.id];
            // console.log(definition);
            doc[column.id] = doc[column.id] || '';
            if (definition['x-ui']) {
                /** if (definition['x-ui']['collection-link']) {
                  let collection = definition['x-ui']['collection-link'];
                  let labelField = definition['x-ui']['collection-link-label'];
                  let valueField = definition['x-ui']['collection-link-value'];

                  let {
                    error,
                    data
                  } = await getOnLocalCollection(collection, doc[column.id]);
                  // console.log(error, data);
                  // console.log('labelField', labelField);
                  if (data) {
                    let keys = labelField.split(',');
                    let text = '';
                    keys.forEach(k => {
                      text += ' ' + data[k.toString().trim()].toString().trim()
                    });
                    doc[column.id] = text.toString().trim();
                  }
                }*/
            }
            // console.log('>>>>>>>>>>>>>>>>', definition);
            // console.log('>>>>>>>>>>>>>>>>', definition.type);
            if (definition.format === 'date-time') {
                if (isDate(doc[column.id])) doc[column.id] = flatpickr.formatDate(new Date(doc[column.id]), 'F j, Y H:i');
            }
            if (definition.format === 'date') {
                if (isDate(doc[column.id])) doc[column.id] = flatpickr.formatDate(new Date(doc[column.id]), 'F j, Y');
            }

        }
        // console.log('XXXXXXXXXXXXXXX', doc);
        nDocs.push(doc);
    }

    // console.log('records', records);
    return nDocs;
}

export function mountDataForGridBasedOnSawgger(swagger, entity, _headers, _data) {
    // console.log('mountDataForGridBasedOnSawgger', entity);
    // console.log('_headers', _headers);
    const data = JSON.parse(JSON.stringify(_data));
    const headers = typeof _headers !== 'undefined' ? JSON.parse(JSON.stringify(_headers)) : [];
    // const headers = JSON.parse(JSON.stringify(_headers));
    let hide = headers.filter(column => {
        return column.hide === true
    });
    const entityDefinition = swagger.definitions[entity];
    const entityProperties = entityDefinition.properties;
    const mongooseFields = ['deleted', 'active', 'createdBy', 'updatedBy', '__v', 'id', 'createdAt', 'updatedAt'];
    let records = data.map(doc => {


        for (let columnName in entityProperties) {
            if (entityProperties.hasOwnProperty(columnName)) {

                let fieldDefinition = entityProperties[columnName];
                let formatedValue = formatGridValueBasedOnDefinition(fieldDefinition, doc[columnName]);
                doc[columnName] = formatedValue;
            } else {
                if (doc[columnName]) {
                    // console.log('delete', columnName);
                    delete doc[columnName];
                }
            }
        }

        for (let x = 0; x < hide.length; x++) {
            let column = hide[x];
            if (typeof doc[column.id] !== 'undefined') {
                // console.log('delete', column.id);
                delete doc[column.id];
            }
        }

        for (let columnName in doc) {
            if (doc.hasOwnProperty(columnName)) {
                if (typeof entityProperties[columnName] === 'undefined') {
                    delete doc[columnName];
                }
            }
        }
        // console.log(doc);
        return doc;
    });
    return records;
}

export function mountDataForGridWithId(_headers, _data) {
    const data = JSON.parse(JSON.stringify(_data));
    const headers = typeof _headers !== 'undefined' ? JSON.parse(JSON.stringify(_headers)) : [];
    // const headers = JSON.parse(JSON.stringify(_headers));
    let hide = headers.filter(column => {
        return column.hide === true
    });
    let records = data.map(doc => {
        // console.log('doc._id', doc._id);
        // console.log('doc', doc);
        for (let x = 0; x < hide.length; x++) {
            let column = hide[x];
            if (column.id !== '_id') delete doc[column.id];
        }
        // console.log('doc._id', doc._id);
        return doc;
    });
    return records;
}

export function isDate(date) {
    return (new Date(date) !== "Invalid Date" && !isNaN(new Date(date))) ? true : false;
}

export function formatValueBasedOnDefinition(fieldDefinition, value) {
    let format = fieldDefinition.format || false;
    if (format === 'date') {
        if (isDate(value)) {
            value = new Date(value).toISOString();
        } else {
            // value = '';
        }
    } else if (format === 'date-time') {
        if (isDate(value)) {
            value = new Date(value).toISOString();
        } else {
            // value = '';
        }
    } else if (format === 'base64') {
        if (value === '' || value === null) {
            value = '/static/avatar.png'; // '/static/avatar.png';
        }
    }
    if (fieldDefinition.type === 'number') {
        if (value === '' || value === null) {
            value = 0; // '/static/avatar.png';
        } else if (typeof value === 'string') {
            value = Number(value);
        }
    }
    // console.log(fieldDefinition, value);
    return value;
}

export function formatGridValueBasedOnDefinition(fieldDefinition, value) {
    let format = fieldDefinition.format || false;
    if (format === 'date') {
        if (isDate(value)) {
            value = moment.tz(value, session.user().timezone).format('ll');
        } else {
            // value = '';
        }
    } else if (format === 'date-time') {
        if (isDate(value)) {
            value = moment.tz(value, session.user().timezone).format('llll');
        } else {
            // value = '';
        }
    }

    // console.log(fieldDefinition, value);
    return value;
}

export function formatRecordBasedOnSwagger(entityDefinition, record) {
    record = JSON.parse(JSON.stringify(record));
    const entityProperties = entityDefinition.properties;
    const fieldsName = Object.keys(entityDefinition.properties);
    for (let columnName in record) {
        if (record.hasOwnProperty(columnName)) {
            if (fieldsName.indexOf(columnName) < 0) {
                delete record[columnName];
                continue;
            }
            let fieldDefinition = entityProperties[columnName];
            let formatedValue = formatValueBasedOnDefinition(fieldDefinition, record[columnName]);
            record[columnName] = formatedValue;
        }
    }

    return record;
}

export function mountRecordBasedOnSwagger(component, record) {
    const entityDefinition = component.swagger.definitions[component.entity];
    let formatedRecord = formatRecordBasedOnSwagger(entityDefinition, record);
    // console.log('formatedRecord', formatedRecord);
    return formatedRecord;
}


export function formatPayloadValueBasedOnDefinition(fieldDefinition, value) {
    let format = fieldDefinition.format || false;
    if (format === 'date') {
        if (isDate(value)) {
            value = new Date(value).toISOString().substr(0, 10);
        } else {
            // value = '';
        }
    }
    if (format === 'date-time') {
        if (isDate(value)) {
            value = new Date(value).toISOString();
        } else {
            // value = '';
        }
    }
    // console.log(fieldDefinition, value);
    return value;
}

/**
 * Function formatPayloadBasedOnSwagger
 * @param {*} component 
 * @param {*} entityDefinition 
 * @param {*} record 
 */
function formatPayloadBasedOnSwagger(component, entityDefinition, record) {
    record = JSON.parse(JSON.stringify(record));
    const entityProperties = entityDefinition.properties;
    const fieldsName = Object.keys(entityDefinition.properties);
    for (let columnName in record) {
        if (record.hasOwnProperty(columnName)) {

            if (fieldsName.indexOf(columnName) < 0) {
                delete record[columnName];
                continue;
            }

            let fieldDefinition = entityProperties[columnName];
            // console.log(columnName, record[columnName]);
            // console.log('fieldDefinition', fieldDefinition);
            let format = fieldDefinition.format || false;
            let type = fieldDefinition.type || string;

            if (columnName === '_id') {
                if (record[columnName] === '' || record[columnName] === null) {
                    delete record[columnName];
                    console.warn(`${columnName} is bad formated and was removed from payload.`, record[columnName]);
                    continue;
                }
            }

            if (format === 'date') {
                if (!isDate(record[columnName])) {
                    delete record[columnName];
                    console.warn(`${columnName} is bad formated and was removed from payload.`, record[columnName]);
                } else {
                    record[columnName] = new Date(record[columnName]).toISOString().substr(0, 10);
                }
            }

            if (format === 'date-time') {
                if (!isDate(record[columnName])) {
                    delete record[columnName];
                    console.warn(`${columnName} is bad formated and was removed from payload.`, record[columnName]);
                } else {
                    record[columnName] = new Date(record[columnName]).toISOString();
                }
            }

            if (type === 'integer' || format === 'integer') {
                if (!isNumber(record[columnName])) {
                    delete record[columnName];
                    console.warn(`${columnName} is bad formated and was removed from payload.`, record[columnName]);
                } else {
                    record[columnName] = parseInt(record[columnName]);
                }
            }

            if (type === 'number' || format === 'number') {
                if (!isNumber(record[columnName])) {
                    delete record[columnName];
                    console.warn(`${columnName} is bad formated and was removed from payload.`, record[columnName]);
                } else {
                    record[columnName] = parseFloat(record[columnName]);
                }
            }

            if (fieldDefinition['x-ui']) {
                if (fieldDefinition['x-ui']['collection-link']) {
                    if (record[columnName] === null || record[columnName] === '') {
                        delete record[columnName];
                        console.warn(`${columnName} is bad formated and was removed from payload.`, record[columnName]);
                    }
                }
            }

            if (type === 'array') {
                if (fieldDefinition.items) {
                    if (fieldDefinition.items.$ref) {
                        let refArray = fieldDefinition.items.$ref.split('/');
                        // sub document schema name
                        let schemaName = refArray[refArray.length - 1];
                        let subFieldDefinition = component.swagger.definitions[schemaName];
                        record[columnName] = record[columnName].map(r => {
                            return formatPayloadBasedOnSwagger(component, subFieldDefinition, r);
                        });
                    }
                }
            }
        }
    }

    return record;
}

/**
 * Public Function mountPayloadBasedOnSwagger
 * prepare payload data to send to server and avoid validation issues. Internally calls formatPayloadBasedOnSwagger
 * @param {*} component 
 * @param {*} record 
 */
export function mountPayloadBasedOnSwagger(component, entity, record, isFormSimple = false) {
    // console.log('mountPayloadBasedOnSwagger');
    // console.log(entity, record);

    const entityDefinition = component.swagger.definitions[entity];
    for (let prop in entityDefinition.properties) {
        if (prop !== '_id')
            if (entityDefinition.properties[prop].readOnly) delete record[prop];

        if (isFormSimple) continue; // dont delete hideFields from payload
        for (let x = 0; x < component.hideFields.length; x++) {
            let hiddenField = component.hideFields[x];
            if (hiddenField.toLowerCase() === prop.toLowerCase()) {
                // delete record[prop];
                if (!getFormRequired(entityDefinition, prop)) delete record[prop];
            }
        }
    }
    let formatedRecord = formatPayloadBasedOnSwagger(component, entityDefinition, record);
    // console.log('formatedRecord', formatedRecord);
    return formatedRecord;
}

// ===================

export function isFormHide(property) {
    if (property) {
        if (property['x-ui']) {
            if (property['x-ui'].form) {
                return property['x-ui'].form.hide === true ? true : false;
            }
        }
    }

    return false;
}

export function isFormMultiple(property) {
    if (property) {
        if (property['x-ui']) {
            if (property['x-ui'].form) { // selection-limit
                if (typeof property['x-ui'].form['selection-limit'] !== 'undefined') { // selection-limit
                    return property['x-ui'].form['selection-limit'] === 0 ? true : false;
                }
            }
        }
    }

    return false;
}

export function getFormLabel(property) {
    if (property) {
        if (property['x-ui']) {
            if (property['x-ui'].form) {
                return property['x-ui'].form.label ? property['x-ui'].form.label : property.description;
            }
        }
    }

    return property.description;
}

export function getFormPlaceHolder(property) {
    if (property) {
        if (property['x-ui']) {
            if (property['x-ui'].form) {
                return property['x-ui'].form.example ? property['x-ui'].form.example : '';
            }
        }
    }

    return '';
}

export function getFormRequired(entityDefinition, fieldName) {
    const required = entityDefinition.required || [];
    return required.indexOf(fieldName) > -1;
}

const vRules = {
    required: value => {
        if (Array.isArray(value)) {
            return value.length > 0 || 'Required.';
        } else {
            return !!value || 'Required.';
        }
    },
    counter: value => value.length <= 20 || 'Max 20 characters',
    email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
    }
};

export function getFormRules(entityDefinition, fieldName, property) {
    let rules = [];
    let isRequired = getFormRequired(entityDefinition, fieldName);

    if (isRequired) {
        rules.push(vRules.required);
    }

    if (isEmail(property)) {
        rules.push(vRules.email);
    }

    return rules;
}

export function getFormMask(property) {
    let mask = '';
    if (property.format) {
        if (property.format === 'date') {
            mask = '####-##-##';
        }
        if (property.format === 'date-time') {
            mask = '####-##-## ##:##';
        }
        if (property.format === 'ssn') {
            mask = '###-##-####';
        }
        if (property.format === 'feid') {
            mask = '##-#######';
        }
        if (property.format === 'password') {
            // mask = '###-##-####';
        }
        if (property.format === 'credit-card') {
            mask = '####-####-####-####';
        }
    }
    if (property) {
        if (property['x-ui']) {
            if (property['x-ui'].form) {
                if (property['x-ui'].form.type === 'date') {
                    mask = '####-##-##';
                }
                if (property['x-ui'].form.format === 'date-time') {
                    mask = '####-##-## ##:##';
                } else if (property['x-ui'].form.format === 'ssn') {
                    mask = '###-##-####';
                }
            }
        }
    }

    return mask;
}

export function getFormAccept(property) {
    let accept = false;
    if (property['x-ui']) {
        if (property['x-ui'].form) {
            if (property['x-ui'].form.accept) {
                accept = property['x-ui'].form.accept
            }
        }
    }
    return accept;
}

export function getFormFileType(property) {
    let type = false;
    let allowed = ['avatar', 'image', 'document'];
    if (property['x-ui']) {
        if (property['x-ui'].form) {
            if (property['x-ui'].form['media-type']) {
                if (allowed.indexOf(property['x-ui'].form['media-type']) > -1) type = property['x-ui'].form['media-type'];
            }
        }
    }
    return type;
}

export function getFormEditable(property) {
    let editable = true;
    if (typeof property['x-editable'] === 'boolean') {
        editable = property['x-editable']
    }

    return editable;
}

export function getFormIsUploader(property) {
    let uploader = false;
    if (typeof property['x-uploader'] === 'boolean') {
        uploader = property['x-uploader']
    }

    return uploader;
}



export function getFormSize(property) {
    let size = 5 * 1024 * 1024; // default is 5MB
    if (property['x-ui']) {
        if (property['x-ui'].form) {
            if (property['x-ui'].form['file-size']) {
                if (isNumber(property['x-ui'].form['file-size'])) size = parseFloat(property['x-ui'].form['file-size']) * 1024 * 1024; // convert to kb
            }
        }
    }
    return size;
}

export function isEmail(property) {
    if (property) {
        if (property['x-ui']) {
            if (property.format) {
                if (property.format === 'email') {
                    return true;
                }
            }
            if (property['x-ui'].form) {
                if (property['x-ui'].form.format === 'email') {
                    return true;
                }
            }
        }
    }

    return false;
}

export function getFormType(property) {
    if (!property) return 'text';
    if (property['x-ui']) {
        if (property.type === 'string') {
            if (property.format === 'date') {
                return 'date';
            } else if (property.format === 'date-time') {
                return 'date-time';
            } else if (property.format === 'base64') {
                return 'base64';
            } else if (property.format === 'file') {
                return 'file';
            } else if (property.format === 'password') {
                return 'password';
            }
            return property['x-ui'].form.type || 'text';
        }
        if (property.type === 'number') {
            if (property['x-format'] === 'currency') {
                return 'currency';
            }
            return 'number';
        }
        if (property.type === 'integer') {
            return 'integer';
        }
        return property['x-ui'].form.type || 'text';
    }
    if (property.type === 'string') {
        if (property.format === 'date') {
            return 'date';
        } else if (property.format === 'date-time') {
            return 'date-time';
        } else if (property.format === 'base64') {
            return 'base64';
        } else if (property.format === 'file') {
            return 'file';
        } else if (property.format === 'password') {
            return 'password';
        }
        return 'text';
    } else if (property.type === 'int') {
        return 'integer';
    } else if (property.type === 'integer') {
        return 'integer';
    } else if (property.type === 'number') {
        if (property['x-format'] === 'currency') {
            return 'currency';
        }
        return 'number';
    } else if (property.type === 'boolean') {
        return 'switch';
    } else if (property.type === 'array') {
        return 'select';
    }
    return 'text';
}

export function getFormDefault(property) {
    let defaultValue = ''; // string
    if (!property) return '';
    if (property.type === 'string') {

        if (property.format === 'date') {
            let d = null;
            defaultValue = d;
        } else if (property.format === 'date-time') {
            let d = null;
            defaultValue = d;
        } else if (property.format === 'base64') {
            defaultValue = null; // '/static/avatar.png';
        } else {
            defaultValue = '';
        }

    } else if (property.type === 'array') {
        defaultValue = [];
    } else if (property.type === 'object') {
        defaultValue = {};
    } else if (property.type === 'boolean') {
        defaultValue = false;
    } else {
        defaultValue = '';
    }
    if (typeof property.default !== 'undefined') {
        defaultValue = property.default;
    }
    return defaultValue;
}


export function getFormInfo(property) {
    if (!property) return '';
    return property.description;
}

export function getFormMaxLength(property) {
    if (!property) return 255;
    if (property.maxLength) {
        return property.maxLength || 255;
    }
    return 255;
}

export function getFormMinLength(property) {
    if (!property) return 0;
    if (property.minLength) {
        return property.minLength || 0;
    }
    return 0;
}


export function setFieldCollectionSettings(settings, property) {
    // console.log(property['x-ui'].form);
    // component.collection_links.push(settings);
    settings.collection = {
        collection: property['x-ui']['collection-link'],
        valueKey: property['x-ui']['collection-link-value'],
        labelKey: property['x-ui']['collection-link-label'],
    };
    return settings;
}

export function getFieldCollectionSettings(property) {
    let collection = false;
    if (property['x-ui']) {
        if (property['x-ui']['collection-link']) {
            collection = {
                collection: property['x-ui']['collection-link'],
                valueKey: property['x-ui']['collection-link-value'],
                labelKey: property['x-ui']['collection-link-label'],
            };
        }
    }

    return collection;
}

export function getDefaultFormFieldSettings(fieldName, property, entityDefinition, collection = false, schemaName = false) {
    let settings = {
        // value: fields[fieldName].description,
        id: fieldName,
        type: getFormType(property),
        hide: isFormHide(property),
        label: getFormLabel(property),
        info: getFormInfo(property),
        schema: false,
        collection,
        schemaName,
        mask: getFormMask(property),
        accept: getFormAccept(property),
        formFileType: getFormFileType(property),
        editable: getFormEditable(property),
        isUploader: getFormIsUploader(property),
        size: getFormSize(property),
        multiple: isFormMultiple(property),
        required: getFormRequired(entityDefinition, fieldName),
        placeholder: getFormPlaceHolder(property),
        vrules: getFormRules(entityDefinition, fieldName, property),
        minlength: getFormMinLength(property),
        maxlength: getFormMaxLength(property),
        $collection: getFieldCollectionSettings(property),
        $schema: entityDefinition,
        swaggerProperty: property,
        defaultValue: getFormDefault(property),
    };
    // if (settings.default === null) delete settings.default;
    return settings;
}

export function getDefaultSubFormObject(name, title, schemaName, schema, collection = false, editable = true, isUploader = false) {
    let settings = {
        name,
        title,
        fields: [],
        values: {},
        labels: {},
        schema,
        collection,
        schemaName,
        isUploader,
        isSchema: false,
        user_values: {},
        headers: {},
        defaultItem: {},
        newItem: {},
        dialog: false,
        editedIndex: -1,
        valid: false,
        editable
    };
    return settings;
}

export function setFormFields(component) {
    const entityDefinition = component.swagger.definitions[component.entity];
    const fields = entityDefinition.properties;
    for (let fieldName in fields) {
        if (fields.hasOwnProperty(fieldName)) {

            let isHide = false;
            for (let x = 0; x < component.hideFields.length; x++) {
                let hiddenField = component.hideFields[x];
                if (hiddenField.toLowerCase() === fieldName.toLowerCase()) {
                    isHide = true;
                }
            }
            if (isHide) continue;


            let property = fields[fieldName];
            if (property['x-ui']) {
                if (property['x-ui'].sub_form_exclude === true) {
                    continue;
                }
            }
            let settings = getDefaultFormFieldSettings(fieldName, property, entityDefinition);

            if (settings.isUploader) {
                console.log('xxxxx uploader found', fieldName);
                component.uploaders.push(fieldName);
            }

            // if is there custom swagger defintion

            if (typeof property['x-ui'] !== 'undefined') {
                // if linked to another collection
                if (typeof property['x-ui']['collection-link'] === 'string') {
                    settings = setFieldCollectionSettings(settings, property);
                    // external collection name
                    let schemaName = property['x-ui']['collection-link'];
                    setSubFormFields(component, fieldName, property, schemaName);
                }

                if (typeof property['x-ui'].form.isSchema === 'boolean') { // if is linked to a schema (sub document)
                    if (property['x-ui'].form.isSchema) {
                        if (property.items) {
                            if (property.items.$ref) {
                                // console.log(property);
                                let refArray = property.items.$ref.split('/');
                                // sub document schema name
                                let schemaName = refArray[refArray.length - 1];
                                // console.info('IS SCHEMA', schemaName);
                                setSubFormFields(component, fieldName, property, schemaName);

                                settings.schema = true;
                                settings.schemaName = schemaName;
                            } else {
                                console.warn(`${fieldName} is declared as x-ui schema but no schema was provided`);
                            }
                        } else {
                            console.warn(`${fieldName} is declared as x-ui schema but no schema was provided`);
                        }

                    }
                }
                // if just a simple multiple value fields
                if (typeof property.enum !== 'undefined') {
                    settings.type = 'select';
                    component.forms.crud.values[fieldName] = [];
                    property.enum.forEach(option => {
                        component.forms.crud.values[fieldName].push(option);
                    });
                }
                if (typeof property['x-ui'].form.options !== 'undefined') {
                    settings.type = 'select';
                    component.forms.crud.values[fieldName] = [];
                    property['x-ui'].form.options.forEach(option => {
                        component.forms.crud.values[fieldName].push(option);
                    });
                }

                // if it is a field grid
                if (getFormType(property) === 'grid') {
                    if (property.items) {
                        if (property.items.$ref) {
                            let refArray = property.items.$ref.split('/');
                            let gridSchemaName = refArray[refArray.length - 1];
                            let properties = component.swagger.definitions[gridSchemaName].properties;
                            setFieldHeaders(component, properties, fieldName);
                        } else {
                            console.warn(`${fieldName} is declared as x-ui schema but no schema was provided`);
                        }
                    } else {
                        console.warn(`${fieldName} is declared as x-ui schema but no schema was provided`);
                    }

                    // console.log('X_X_X_X_X_X_X_X_X_X', fieldName);
                    // console.log('component.forms.crud.headers[fieldName]', component.forms.crud.headers[fieldName]);
                }
            }

            // if it is a date picker
            if (getFormType(property) === 'date') {
                component.forms.crud.user_values[fieldName] = null;
            }



            if (getFormType(property) === 'date-time') {
                component.forms.crud.user_values[fieldName] = null;
            }

            if (getFormType(property) === 'base64') {
                component.forms.crud.user_values[fieldName] = null; // '/static/avatar.png';
            }

            component.forms.crud.fields.push(settings);
        }
    }
}

function setFieldHeaders(component, properties, fieldName) {
    Vue.set(component.forms.crud.headers, fieldName, []);
    for (let prop in properties) {
        if (properties.hasOwnProperty(prop)) {
            // console.log('xxxx------', prop);
            // console.log('xxxx------', properties[prop]);
            if (properties[prop]['x-ui']) {
                if (properties[prop]['x-ui'].grid) {
                    if (properties[prop]['x-ui'].grid.hide === false) {
                        let gridSettings = getDefaultGridColumnSettings(prop, properties[prop]);
                        component.forms.crud.headers[fieldName].push(gridSettings);
                    }
                }
            } else {
                let gridSettings = getDefaultGridColumnSettings(prop);
                component.forms.crud.headers[fieldName].push(gridSettings);
            }
        }
    }
}

export function setSubFormFields(component, parentFieldName, parentProperty, schemaName = false) {
    // console.info('setSubFormFields ----->>>>>>>');
    // console.info('parentFieldName', parentFieldName);
    // console.info('parentProperty', parentProperty);
    // console.info('schemaName', schemaName);
    const entityDefinition = component.swagger.definitions[schemaName];
    const fields = entityDefinition.properties;
    let collection = false;
    if (parentProperty['x-ui']) {
        if (parentProperty['x-ui']['collection-link']) {
            collection = parentProperty['x-ui']['collection-link'];
        }
    }
    // console.log('setSubFormFields ------>', parentProperty);
    const subForm = getDefaultSubFormObject(parentFieldName, parentProperty.description, schemaName, entityDefinition, collection, getFormIsUploader(parentProperty));

    // set subform on memory and make it reactive
    Vue.set(component.forms, parentFieldName, subForm);

    for (let fieldName in fields) {
        if (fields.hasOwnProperty(fieldName)) {

            let isHide = false;
            // console.log('component.hideSubFields', component.hideSubFields);
            for (let _formName in component.hideSubFields) {
                if (_formName !== schemaName) continue; // make sue we will hide only fields for specified form
                let hideFields = component.hideSubFields[_formName];
                for (let x = 0; x < hideFields.length; x++) {
                    let hiddenField = hideFields[x];
                    if (hiddenField.toLowerCase() === fieldName.toLowerCase()) {
                        isHide = true
                    }
                }
            }
            if (isHide) continue;

            let property = fields[fieldName];
            if (property['x-ui']) {
                if (property['x-ui'].form.hide === true && fieldName !== '_id') {
                    continue;
                }
            }
            let settings = getDefaultFormFieldSettings(fieldName, property, entityDefinition);

            // component.forms[parentFieldName].headers[fieldName] = [];

            Vue.set(component.forms[parentFieldName].headers, fieldName, []);



            // if is there custom swagger defintion
            if (typeof property['x-ui'] !== 'undefined') {

                // if field is linked to another collection
                if (typeof property['x-ui']['collection-link'] === 'string') {
                    settings = setFieldCollectionSettings(settings, property);
                    // console.log('settings', settings);
                }

                if (typeof property['x-ui'].form.isSchema === 'boolean') { // if is linked to a schema
                    if (property['x-ui'].form.isSchema) {
                        settings.schema = true;
                    }
                }
                // if just a simple multiple value fields
                if (typeof property.enum !== 'undefined') {
                    settings.type = 'select';
                    component.forms[parentFieldName].values[fieldName] = [];
                    property.enum.forEach(option => {
                        component.forms[parentFieldName].values[fieldName].push(option);
                    });
                }
                if (typeof property['x-ui'].form.options !== 'undefined') {
                    settings.type = 'select';
                    component.forms[parentFieldName].values[fieldName] = [];
                    property['x-ui'].form.options.forEach(option => {
                        component.forms[parentFieldName].values[fieldName].push(option);
                    });
                }
            }

            // if it is a field grid
            if (getFormType(property) === 'grid') {
                if (property.items) {
                    if (property.items.$ref) {
                        let refArray = property.items.$ref.split('/');
                        let schemaName = refArray[refArray.length - 1];
                        let properties = component.swagger.definitions[schemaName].properties;
                        for (let prop in properties) {
                            if (properties.hasOwnProperty(prop)) {
                                let gridSettings = getDefaultGridColumnSettings(prop, properties[prop]);
                                component.forms[parentFieldName].headers[fieldName].push(gridSettings);
                            }
                        }
                    } else {
                        console.warn(`${parentFieldName} is declared as x-ui schema but no schema was provided`);
                    }
                } else {
                    console.warn(`${parentFieldName} is declared as x-ui schema but no schema was provided`);
                }
            }

            component.forms[parentFieldName].user_values[fieldName] = getFormDefault(property);
            component.forms[parentFieldName].defaultItem[fieldName] = getFormDefault(property);
            component.forms[parentFieldName].fields.push(settings);
        }
    }
}


// ========


export async function getDataFromApi(url, component, where = false, populate = '') {
    // console.log('URL URL URL', url);
    component.loading = true;
    const {
        sortBy,
        descending,
        page,
        rowsPerPage
    } = component.pagination;
    const order = descending ? -1 : 1;
    const offset = page * rowsPerPage - rowsPerPage;
    if (where) {
        where = JSON.stringify(where);
    }
    // console.log(where);
    let response = await session.http({
        url: where ?
            `${url}?limit=${rowsPerPage}&offset=${offset}&sort={"${sortBy}":${order}}&where=${where}&populate=${populate}` : `${url}?limit=${rowsPerPage}&offset=${offset}&sort={"${sortBy}":${order}}&populate=${populate}`
    });
    let data = null;
    if (response.data) {
        data = response.data.map(doc => {
            let newDoc = {};
            for (let prop in component.swagger.definitions[component.entity].properties) {
                if (component.swagger.definitions[component.entity].properties.hasOwnProperty(prop)) {
                    let property = component.swagger.definitions[component.entity].properties[prop];
                    // if (property.type === 'string' || property.type === 'number') 
                    newDoc[prop] = doc[prop];
                }
            }
            return newDoc;
        });
    }

    component.loading = false;
    return {
        data,
        allData: response.data,
        total: response.count,
        error: response.error || null
    };
}

export async function getFromApi(url, component, where = false, populate = '') {
    component.loading = true;
    const {
        sortBy,
        descending,
        page,
        rowsPerPage
    } = component.pagination;
    const order = descending ? -1 : 1;
    const offset = page * rowsPerPage - rowsPerPage;
    where = where ? JSON.stringify(where) : false;
    let uri = where ? `${url}?limit=${rowsPerPage}&offset=${offset}&sort={"${sortBy}":${order}}&where=${where}&populate=${populate}` : `${url}?limit=${rowsPerPage}&offset=${offset}&sort={"${sortBy}":${order}}&populate=${populate}`;
    let response = await session.http({
        url: uri
    });
    response.total = response.count;
    component.loading = false;
    return response;
}

export async function create(entity, payload) {
    delete payload.id;
    delete payload._id;
    let data = JSON.stringify(payload);
    let type = 'POST';
    let url = entity;
    let response = await session.http({
        type,
        url,
        data
    });
    // console.log('create');
    // console.log(response);


    return response;
}

export async function update(entity, payload, id) {
    /* Remove children_count from Account */
    if (entity === 'Account' && typeof payload.children_count !== 'undefined' && payload.children_count === null) {
        delete payload.children_count;
    }
    let oldId = payload.id;
    let _id = payload._id;
    delete payload.id;
    delete payload._id;
    let data = JSON.stringify(payload);
    let type = 'PUT';
    let url = entity + `/${id}`;
    let response = await session.http({
        type,
        url,
        data
    });
    if (response.error) {
        payload.id = oldId;
        payload._id = _id;
    }
    return response;
}

export async function updateMany(entity, where, set) {
    
    let payload = {};
    payload.where = where;
    payload.set = set;
    let data = JSON.stringify(payload);
    let type = 'PUT';
    let url = entity;
    let response = await session.http({
        type,
        url,
        data
    });
    return response;
}

export async function remove(entity, id, mode = 'hard') {
    let type = 'DELETE';
    let url = entity + `/${id}?mode=${mode}`;
    let response = await session.http({
        type,
        url
    });
    // console.log(response);
    return response;
}

export async function restore(entity, id) {
    let type = 'PATCH';
    let url = entity + `/${id}`;
    let response = await session.http({
        type,
        url
    });
    // console.log(response);
    return response;
}


export async function getOne(entity, id, populate = '', attributes = null) {
    let queryString = '';
    queryString += populate !== '' ? '?populate=' + (typeof populate === 'string' ? populate : JSON.stringify(populate)) : '';
    queryString += attributes ? (populate ? '&' : '?') + 'attributes=' + attributes : '';
    let response = await session.http({
        url: `${entity}/${id}${queryString}`
    });
    return response;
}

export async function getCollection(collection, returnAll = false, limit = 10, populate = '', where = {}, attributes = null, callback = null, sort = {}, bgFetch = false) {
    collection = collection.replace(/ /gi, '');
    let error = false;
    let data = false;
    let count = 0;
    let queryString = '';
    queryString += !returnAll ? '&limit=' + limit : '';
    queryString += populate !== '' ? '&populate=' + (typeof populate === 'string' ? populate : JSON.stringify(populate)) : '';
    queryString += sort === {} ? '' : '&sort=' + JSON.stringify(sort);
    queryString += attributes ? '&attributes=' + attributes : '';
    queryString += where === {} ? '' : '&where=' + JSON.stringify(where);
    let response = await session.http({
        url: `${collection}?returnAll=${returnAll}${queryString}`,
        bgFetch: bgFetch
    });
    error = response.error;
    data = response.data;
    count = response.count;
    if (callback) {
        callback(error, data, count);
    } else {
        return {
            error,
            data,
            count
        };
    }
}


export async function bulkGetCollections(collections = {}, lastSyncDate = false) {
    // console.log('bulkGetCollections', lastSyncDate);
    collections = JSON.stringify(collections);
    let url = `bulk?collections=${collections}`;
    if (lastSyncDate) {
        url = `bulk?collections=${collections}&lastSyncDate=${lastSyncDate}`;
    }
    // console.log(url);
    let response = await session.http({
        url: url
    });
    let error = response.error;
    let data = response.data;
    return {
        error,
        data
    };
}


export async function getLocalCollection(collection, keys) {
    // console.log(collection);
    collection = collection.replace(/ /gi, '');
    // console.log(collection);
    let data = false;
    let error = false;
    try {
        // console.time('getAll local ' + collection);
        data = (await Mediator.client.store.models[collection].getAll()).filter(d => {
            if (d.deleted === true) return false;
            return true;
        });
        // console.log(data);
        // console.log('-------XXXXXX--------');
        // await Mediator.client.store.models[collection].search();
        // console.timeEnd('getAll local ' + collection);
        // console.log(Mediator.client.store.$db);
        // data = await Mediator.client.store.$db._db.getAllFromIndex(collection, 'createdAt');
        // console.log(data);
        // let notSentMessages = await self.store.models.SocketMessage.findAllByIndexValue('sent', 0)
        // console.log(entityName, newDocument)
    } catch (e) {
        // console.log('error finding all by index doc ', e);
        error = e;
    }
    return {
        error,
        data
    };
}

export function jsUcfirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export async function getOnLocalCollection(collection, _id) {
    // console.log(collection);
    collection = jsUcfirst(collection.replace(/ /gi, ''));
    // console.log(collection);
    // console.log(Mediator.client.store.models);
    let data = false;
    let error = false;
    try {
        // console.time('getAll local ' + collection);
        data = await Mediator.client.store.models[collection].get(_id);
        // console.log(data);
        // console.log('-------XXXXXX--------');
        // await Mediator.client.store.models[collection].search();
        // console.timeEnd('getAll local ' + collection);
        // console.log(Mediator.client.store.$db);
        // data = await Mediator.client.store.$db._db.getAllFromIndex(collection, 'createdAt');
        // console.log(data);
        // let notSentMessages = await self.store.models.SocketMessage.findAllByIndexValue('sent', 0)
        // console.log(entityName, newDocument)
    } catch (e) {
        // console.log('error finding all by index doc ', e);
        error = e;
    }
    return {
        error,
        data
    };
}


export function mountFieldQuery(objValues, objOperators, property, innerQuery, logicalOperator) {
    let value = objValues[property];
    let operator = objOperators[property];
    let childQuery = {};
    if (operator === 'eq') {
        if (typeof value !== 'string') return {
            innerQuery
        };
        if (value === '') return {
            innerQuery
        };
        childQuery = {};
        childQuery[property] = {
            '$eq': String(value)
        };
        innerQuery[logicalOperator].push(childQuery);
    } else if (operator === 'ne') {
        if (typeof value !== 'string') return {
            innerQuery
        };
        if (value === '') return {
            innerQuery
        };
        childQuery = {};
        childQuery[property] = {
            '$ne': String(value)
        };
        innerQuery[logicalOperator].push(childQuery);
    } else if (operator === 'isNull') {
        childQuery = {};
        childQuery[property] = {
            '$eq': null
        };
        innerQuery[logicalOperator].push(childQuery);
    } else if (operator === 'isNotNull') {
        childQuery = {};
        childQuery[property] = {
            '$ne': null
        };
        innerQuery[logicalOperator].push(childQuery);
    } else if (operator === 'isEmpty') {
        childQuery = {};
        childQuery[property] = {
            '$eq': ''
        };
        innerQuery[logicalOperator].push(childQuery);
    } else if (operator === 'contains') {
        if (typeof value !== 'string') return {
            innerQuery
        };
        if (value === '') return {
            innerQuery
        };
        childQuery = {};
        childQuery[property] = {
            '$regex': String(value),
            $options: 'i' // i is slower due not use index
        };
        innerQuery[logicalOperator].push(childQuery);
    } else if (operator === 'doesNotContains') {
        if (typeof value !== 'string') return {
            innerQuery
        };
        if (value === '') return {
            innerQuery
        };
        childQuery = {};
        childQuery[property] = {
            '$regex': String('^((?!' + value + ').)*$'),
            $options: 'i' // i is slower due not use index
        };
        innerQuery[logicalOperator].push(childQuery);
    } else if (operator === 'startsWith') {
        if (typeof value !== 'string') return {
            innerQuery
        };
        if (value === '') return {
            innerQuery
        };
        childQuery = {};
        childQuery[property] = {
            '$regex': String('^' + value),
            $options: 'im' // i is slower due not use index
        };
        innerQuery[logicalOperator].push(childQuery);
    } else if (operator === 'endsWith') {
        if (typeof value !== 'string') return {
            innerQuery
        };
        if (value === '') return {
            innerQuery
        };
        childQuery = {};
        childQuery[property] = {
            '$regex': String(value + '$'),
            $options: 'im' // i is slower due not use index
        };
        innerQuery[logicalOperator].push(childQuery);
    } else if (operator === 'gt') {
        childQuery = {};
        childQuery[property] = {
            '$gt': value
        };
        innerQuery[logicalOperator].push(childQuery);
    } else if (operator === 'gte') {
        childQuery = {};
        childQuery[property] = {
            '$gte': value
        };
        innerQuery[logicalOperator].push(childQuery);
    } else if (operator === 'lt') {
        childQuery = {};
        childQuery[property] = {
            '$lt': value
        };
        innerQuery[logicalOperator].push(childQuery);
    } else if (operator === 'lte') {
        childQuery = {};
        childQuery[property] = {
            '$lte': value
        };
        innerQuery[logicalOperator].push(childQuery);
    } else if (operator === 'between') {
        if (value === '') return {
            innerQuery
        };
        let value_2 = '';
        if (value.indexOf(' to ') > -1) {
            let strDateRange = value.split(' to ');
            value = strDateRange[0];
            value_2 = strDateRange[1];
        }

        if (value_2 === '') return {
            innerQuery
        };
        if (value_2 === null) return {
            innerQuery
        };
        if (typeof value_2 === 'undefined') return {
            innerQuery
        };

        if (isDate(value) && isDate(value_2)) {
            childQuery = {};
            childQuery[property] = {
                '$gte': new Date(value).toISOString(),
                '$lt': new Date(value_2).toISOString()
            };
            innerQuery[logicalOperator].push(childQuery);
        } else {
            return {
                innerQuery
            }
        }
    } else if (operator === 'notBetween') {
        // 
    }
    return {
        innerQuery
    };
}

export function getVmFieldById(id, fields) {
    let field = false;
    fields.forEach(f => {
        if (f.id === id) field = f;
    });
    return field;
}

export function isValidDate(d, m, y) {
    m = parseInt(m, 10) - 1;
    return m >= 0 && m < 12 && d > 0 && d <= daysInMonth(m, y);
}

export function isIdValid(_id) {
    if (typeof _id !== 'string') return false;
    if (_id === '') return false;
    return true;
}

export function uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        let r = Math.random() * 16 | 0,
            v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
    })
}



export function closeForm(component, isSearch = false) {
    Swal.fire({
        title: 'Are you done?',
        text: `Please cancel if you want to ${component.currentFormMode} ${component.currentFormMode === 'create' ? 'more items' : 'this item'} !`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, close it!',
        backdrop: `
      rgba(0,0,123,0.4)
      url("./static/nyan-cat.gif")
      center left
      no-repeat
    `
    }).then((result) => {
        if (result.value) {
            component.bus.$emit('displayWhat', 'grid');
            component.forms.crud.user_values = Object.assign({}, component.forms.crud.defaultItem);
            component.forms.crud.editedIndex = -1;
            clearFieldsValues(component, isSearch ? 'search' : 'crud');
        }
    });

}

export function closeSubForm(component, name) {
    //component.currentFormMode // create update
    // console.log('closeSubForm', name);

    Swal.fire({
        title: 'Are you done?',
        text: 'Please cancel if you want to add more items!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, close it!',
        backdrop: `
      rgba(0,0,123,0.4)
      url("./static/nyan-cat.gif")
      center left
      no-repeat
    `
    }).then((result) => {
        if (result.value) {

            // component.bus.$emit('displayWhat', 'grid');
            //component.forms[name].user_values = Object.assign({}, component.forms[name].defaultItem);
            //component.forms[name].editedIndex = -1;
            clearFieldsValues(component, name);

            if (component.currentFormMode === 'create') {
                component.bus.$emit('createItem', false);
            } else if (component.currentFormMode === 'update') {
                component.bus.$emit('editCRUDItem', component.forms.crud.editedIndex);
            }
        }
    });


}


export async function displayWhat(component, what, isSearch) {
    // console.log('------------> displayWhat', what);
    if (what !== 'grid' && what !== 'crud') {
        // closeForm(component);
    }
    component.displayWhat = what;
    component.$emit('toTop');
    if (what !== 'grid') {
        component.dialog_loading = true;
        component.loading = true;
        await feedFieldsValues(component, what === 'search' ? 'crud' : what, isSearch);
        component.dialog_loading = false;
        component.loading = false;
    }

    //if (what === 'grid') {
    //component.currentFormMode = null;
    //}
}
export function setXCrudMediatorDataSync(component) {

    Mediator.client.on('data:sync', async(eventObj) => {
        if (!eventObj.success) return;

        if (eventObj.entity !== component.entity) return;

        if (eventObj.action === 'create') {
            addNewDocumentToVm(component, eventObj.data);
        } else if (eventObj.action === 'update' || eventObj.action === 'restore' || eventObj.action === 'delete') {
            let {
                document,
                index
            } = getDocumentById(component, eventObj.data._id);
            if (document) {
                // feedGrid(component);
                updateDocumentOnVm(component, eventObj.data, index);
            }
        } else if (eventObj.action === 'delete_hard') {
            let {
                document,
                index
            } = getDocumentById(component, eventObj.data._id);
            if (document) {
                // feedGrid(component);
                deleteDocumentOnVm(component, document, index);
            }
        }
    });
}

export async function updateRecord(component, isFormSimple) {
    let copy = Object.assign({}, component.forms.crud.user_values);
    console.log('updateRecord', copy);
    let formatedRecord = mountPayloadBasedOnSwagger(component, component.entity, copy, isFormSimple);
    console.log('updateRecord formatedRecord', formatedRecord);
    let {
        data,
        error
    } = await update(component.entity, formatedRecord, copy._id);
    component.bus.$emit('savedOnServer', {
        data,
        error
    });
    if (error) {
        console.error('error on update', error);
        return {
            data,
            error
        };
    }
    return {
        data,
        error
    };
};

export async function createRecord(component, isFormSimple) {
    // create
    let formatedRecord = mountPayloadBasedOnSwagger(component, component.entity, component.forms.crud.user_values, isFormSimple);
    // console.log('formatedRecord', formatedRecord);
    let {
        data,
        error
    } = await create(component.entity, formatedRecord);
    component.bus.$emit('savedOnServer', {
        data,
        error
    });
    if (error) {
        console.error('error on create', error);
        return {
            data,
            error
        };
    }

    // component.documents = mountDataForGridBasedOnSawgger(component.swagger, component.entity, component.headers, component.documents);
    return {
        data,
        error
    };
};

export async function save(component, isFormSimple) {
    console.log(component.$refs);
    console.log(component.$refs.xForm);
    console.log(component.$refs.xForm.$refs);
    let response = {
        error: false,
        data: false
    };
    const vForm = component.$refs.xForm.$refs['form_crud_' + component.entity];
    if (vForm.validate()) {
        response = await processForm(component, isFormSimple);
    } else {
        showSnack(component, 'Please check the form');
    }
    return response;
};

export async function processForm(component, isFormSimple) {
    component.dialog_loading = true;
    component.loading = true;
    let response = {
        error: false,
        data: false
    };
    if (component.forms.crud.editedIndex > -1) {
        response = await updateDocument(component, isFormSimple);
    } else {
        response = await createDocument(component, isFormSimple);
    }
    component.dialog_loading = false;
    component.loading = false;
    return response;
};

export async function updateDocument(component, isFormSimple) {
    let {
        data,
        error
    } = await updateRecord(component, isFormSimple);
    let errorMessage = false;
    if (!error) {
        // updateDocumentOnVm(component, data);
        if (!isFormSimple) feedGrid(component);
        component.bus.$emit('displayWhat', 'crud');
    } else {
        errorMessage = error.message || error;
    }
    if (!errorMessage) {
        if (!isFormSimple) component.bus.$emit('close');
    }
    showSnack(component, errorMessage);
    return {
        data,
        error
    }
};

export async function createDocument(component, isFormSimple) {
    let {
        data,
        error
    } = await createRecord(component, isFormSimple);
    let errorMessage = false;
    if (!error) {
        // addNewDocumentToVm(component, data);
        if (!isFormSimple) feedGrid(component);
    } else {
        errorMessage = error.message || error;
    }
    if ((!errorMessage) && (!isFormSimple)) {
        component.forms.crud.user_values = Object.assign({}, component.forms.crud.defaultItem);
        component.forms.crud.editedIndex = -1;
        component.bus.$emit('close');
    }
    showSnack(component, errorMessage);
    return {
        data,
        error
    }
};







export function editItem(component, index) {
    // console.log('editItem')
    // console.log(component.original_documents[index])
    let item = mountRecordBasedOnSwagger(component, component.original_documents[index]);
    // console.log('item', item);
    component.forms.crud.editedIndex = index;
    // console.log('editItem', item);
    component.forms.crud.user_values = Object.assign({}, item);
    component.currentFormMode = 'update';
    component.bus.$emit('displayWhat', 'crud');
    // component.bus.$emit('setDialog');
}

export function createItem(component, isEmpty = true) {
    console.log('---->>>> Start CREATE ITEM');
    console.log('component.forms.crud.user_values', component.forms.crud.user_values);
    component.forms.crud.editedIndex = -1;
    component.currentFormMode = 'create';
    if (isEmpty) {
        console.warn('assigning default values');
        component.forms.crud.user_values = Object.assign({}, component.forms.crud.defaultItem);
    } else {
        console.warn('using component.forms.crud.user_values');
        // user has filled form crud before
    }

    // check if something was created in formgrid and and fill form field
    if (component.original_documents[component.forms.crud.editedIndex]) {
        console.log('adding properties from component.original_documents[-1] on createItem', component.original_documents[component.forms.crud.editedIndex]);
        for (let prop in component.original_documents[component.forms.crud.editedIndex]) {
            console.log('prop from component.original_documents[-1]', prop);
            console.log(component.original_documents[component.forms.crud.editedIndex][prop]);
            Vue.set(component.forms.crud.user_values, prop, component.original_documents[component.forms.crud.editedIndex][prop]);
        }
    }

    console.log('---->>>> End CREATE ITEM');
    component.bus.$emit('displayWhat', 'crud');

    // component.bus.$emit('setDialog');
}

export function editSubFormItem(component, item, formName, index) {
    component.bus.$emit('openSubForm', formName);
    component.forms[formName].editedIndex = index;
    // console.log('editSubFormItem item', item);
    component.forms[formName].user_values = Object.assign({}, item);
}

export function fillField(component, collection, _id, fieldId) {
    window.setTimeout(() => {
        // console.log('DDDDDDDDDDDDDDD', _id);
        // console.log('DDDDDDDDDDDDDDD field', fieldId);
        _fillField(component, collection, _id, fieldId);
    }, 700);
};

function getProperty(component, entityName, propertyName) {
    // console.log(entityName, propertyName);
    return component.swagger.definitions[entityName] ? component.swagger.definitions[entityName].properties[propertyName] : false;
};

function _fillField(component, collection, _id, fieldId) {
    // console.log('DDDDDDDDDDDDDDD', _id);
    // console.log('DDDDDDDDDDDDDDD field', fieldId);
    if (!_id) {
        try {
            document.getElementById(fieldId).innerHTML = 'none';
        } catch (error) {
            console.warn('element does not exist ' + fieldId);
        }
        return;
    }
    if (!document.getElementById(fieldId)) {
        return;
    }
    (async(elId) => {
        // if (!document.getElementById(elId)) return;
        try {
            let {
                error,
                data
            } = await getOnLocalCollection(collection.collection, _id);
            let keys = collection.labelKey.split(',');
            let text = '';
            keys.forEach(k => {
                text += ' ' + data[k.toString().trim()].toString().trim();
            });
            document.getElementById(elId).innerHTML = text;
        } catch (error) {
            // console.log(error);
            console.warn('error on filling field', fieldId);
            console.warn('searching for:', collection.collection);
            console.warn('value:', _id);
            console.warn('target div id:', elId);
        }
    })(fieldId);
};
export function previewSubFormItem(component, item, formName, index) {

    let strTemplate = '';
    console.log(item);
    console.log(formName);
    console.log(component.entity);
    item = JSON.parse(JSON.stringify(item))
    let property = component.swagger.definitions[component.entity].properties[formName];
    console.log(property);
    let refArray = property.items.$ref.split('/');
    // sub document schema name
    let schemaName = refArray[refArray.length - 1];
    let subFieldDefinition = component.swagger.definitions[schemaName].properties;

    // console.log(property);
    for (let prop in item) {
        if (prop === '_id') continue;

        let sProperty = subFieldDefinition[prop];
        let fType = getFormType(sProperty)
        if (fType === 'currency') {
            item[prop] = parseFloat(item[prop]).toFixed(2)
        }
        if (fType === 'date') {
            item[prop] = flatpickr.formatDate(new Date(item[prop]), 'F j, Y');
        }
        if (fType === 'date-time') {
            item[prop] = flatpickr.formatDate(new Date(item[prop]), 'F j, Y H:i')
        }

        let $collection = getFieldCollectionSettings(sProperty)
            // console.log('$collection', $collection);
        if ($collection) {
            if ($collection.collection) {
                let val = item[prop];
                item[prop] = `<div style="float:left; width: 50%; padding: 5px;" id="sel_preview_${prop}">
          <img style="max-width:36px;" class="centered" src="./static/loading.gif">
        </div>`;
                window.setTimeout(() => {
                    fillField(component, $collection, val, 'sel_preview_' + prop)
                }, 300)
            }
        }
        strTemplate += `<div style="float:left; width: 100%;"><p style="float:left; width: 50%;">${component.swagger.definitions[schemaName].properties[prop].description}:</p> ${item[prop]}</div>`;
    }
    Swal.fire({
        title: `<strong>Preview ${formName} detail</strong>`,
        type: 'info',
        html: strTemplate,
        showCloseButton: true,
        showCancelButton: false,
        focusConfirm: false,
        confirmButtonText: 'Close',
    });
}

export function previewGenericItem(component, item, entity, index) {

    let strTemplate = '';
    console.log(item);
    console.log(entity);

    item = JSON.parse(JSON.stringify(item))

    let subFieldDefinition = component.swagger.definitions[entity].properties;

    // console.log(property);
    for (let prop in item) {
        if (prop === '_id') continue;
        if (!subFieldDefinition[prop]) continue;
        let sProperty = subFieldDefinition[prop];
        let fType = getFormType(sProperty)
        if (fType === 'currency') {
            item[prop] = parseFloat(item[prop]).toFixed(2)
        }
        if (fType === 'date') {
            item[prop] = flatpickr.formatDate(new Date(item[prop]), 'F j, Y');
        }
        if (fType === 'date-time') {
            item[prop] = flatpickr.formatDate(new Date(item[prop]), 'F j, Y H:i')
        }

        let $collection = getFieldCollectionSettings(sProperty)
            // console.log('$collection', $collection);
        if ($collection) {
            if ($collection.collection) {
                let val = item[prop];
                item[prop] = `<div style="float:left; width: 50%; padding: 5px;" id="sel_preview_${prop}">
          <img style="max-width:36px;" class="centered" src="./static/loading.gif">
        </div>`;
                window.setTimeout(() => {
                    fillField(component, $collection, val, 'sel_preview_' + prop)
                }, 300)
            }
        }
        strTemplate += `<div style="float:left; width: 100%;"><p style="float:left; width: 50%;">${component.swagger.definitions[entity].properties[prop].description}: ${fType}</p> ${item[prop]}</div>`;
    }
    Swal.fire({
        title: `<strong>Preview ${entity} detail</strong>`,
        type: 'info',
        html: strTemplate,
        showCloseButton: true,
        showCancelButton: false,
        focusConfirm: false,
        confirmButtonText: 'Close',
    });
}

export function previewUploadedFile(component, item, formName, index) {

    let strTemplate = '';
    // console.log(item);
    item = JSON.parse(JSON.stringify(item))
    let property = component.swagger.definitions[component.entity].properties[formName];
    let refArray = property.items.$ref.split('/');
    // sub document schema name
    let schemaName = refArray[refArray.length - 1];
    let subFieldDefinition = component.swagger.definitions[schemaName].properties;

    // console.log(property);
    for (let prop in item) {
        if (prop === '_id' || prop === 'path' || prop === 'name') continue;

        let sProperty = subFieldDefinition[prop];
        let fType = getFormType(sProperty)
        if (fType === 'currency') {
            item[prop] = parseFloat(item[prop]).toFixed(2)
        }
        if (fType === 'date') {
            item[prop] = flatpickr.formatDate(new Date(item[prop]), 'F j, Y');
        }
        if (fType === 'date-time') {
            item[prop] = flatpickr.formatDate(new Date(item[prop]), 'F j, Y H:i')
        }

        if (prop === 'webPath') {
            item[prop] = `<a style="cursor:pointer;" onclick="window.open('${item.webPath}', 'Download');">click to download</a>`
        }

        let $collection = getFieldCollectionSettings(sProperty)
            // console.log('$collection', $collection);
        if ($collection) {
            if ($collection.collection) {
                let val = item[prop];
                item[prop] = `<div style="float:left; width: 50%; padding: 5px;" id="sel_preview_${prop}">
          <img style="max-width:36px;" class="centered" src="./static/loading.gif">
        </div>`;
                window.setTimeout(() => {
                    fillField(component, $collection, val, 'sel_preview_' + prop)
                }, 300)
            }
        }
        strTemplate += `<div style="float:left; width: 100%;"><p style="float:left; width: 50%;">${component.swagger.definitions[schemaName].properties[prop].description}:</p> ${item[prop]}</div>`;
    }
    Swal.fire({
        title: `<strong>Preview ${formName} detail</strong>`,
        type: 'info',
        html: strTemplate,
        showCloseButton: true,
        showCancelButton: false,
        focusConfirm: false,
        confirmButtonText: 'Close',
    });
}

export function deleteSubFormItem(component, item, formName, index) {
    component.forms.crud.values[formName].splice(index, 1);
    component.forms.crud.user_values[formName].splice(index, 1);
    component.forms[formName].editedIndex = -1;
}

export async function deleteItem(component, item = false, mode = 'soft') {
    let errors = [];
    let deleted = [];

    if (item) {
        if (isIdValid(item._id)) {
            let {
                error,
                data
            } = await remove(component.entity, item._id, mode);
            if (error) {
                errors.push(error);
                showSnack(component, component.entity + ' ' + item._id + ' is not deleted');
            } else if (data) {
                deleted.push(data);
                component.selected = [];
                showSnack(component, false, component.entity + ' ' + item._id + ' is deleted');
                feedGrid(component);
            }
        } else {
            errors.push('invalid ID');
            showSnack(component, component.entity + ' is not deleted. Invalid ID');
        }
    } else {
        // console.log(component.selected);
        for (let x = 0; x < component.selected.length; x++) {
            let item = component.selected[x];
            if (isIdValid(item._id)) {
                let {
                    error,
                    data
                } = await remove(component.entity, item._id, mode);
                if (error) {
                    errors.push(error);
                    showSnack(component, component.entity + ' ' + item._id + ' is not deleted');
                } else if (data) {
                    component.selected = [];
                    deleted.push(data);
                    showSnack(component, false, component.entity + ' ' + item._id + ' is deleted');
                }
            } else {
                errors.push('invalid ID');
                showSnack(component, component.entity + ' is not deleted. Invalid ID');
            }
        }
        if (deleted.length > 0) feedGrid(component);
    }
    return {
        error: errors,
        data: deleted
    };
};

export async function restoreItem(component, item = false) {
    let errors = [];
    let restored = [];
    if (item) {
        if (isIdValid(item._id)) {
            let {
                error,
                data
            } = await restore(component.entity, item._id);
            if (error) {
                errors.push(error);
                showSnack(component, component.entity + ' ' + item._id + ' is not restored');
            } else if (data) {
                restored.push(data);
                showSnack(component, false, component.entity + ' ' + item._id + ' is restored');
                feedGrid(component);
            }
        } else {
            errors.push('invalid ID');
            showSnack(component, component.entity + ' is not restored. Invalid ID');
        }
        /**  */
    } else {
        // console.log(component.selected);
        for (let x = 0; x < component.selected.length; x++) {
            let item = component.selected[x];
            if (isIdValid(item._id)) {
                let {
                    error,
                    data
                } = await restore(component.entity, item._id);
                if (error) {
                    errors.push(error);
                    showSnack(component, component.entity + ' ' + item._id + ' is not restored');
                } else if (data) {
                    restored.push(data);
                    showSnack(component, false, component.entity + ' ' + item._id + ' is restored');
                }
            } else {
                errors.push('invalid ID');
                showSnack(component, component.entity + ' is not restored. Invalid ID');
            }
        }
        if (restored.length > 0) feedGrid(component);
    }
    return {
        error: errors,
        data: restored
    };
}

export function setXCrudMainListeners(component) {
    component.bus.$on('readPhotoFile', (fieldId, base64) => readPhotoFile(component, fieldId, base64));

    component.bus.$on('feedGrid', () => feedGrid(component));
    component.bus.$on('setPagination', (pagination) => {
        component.pagination = Object.assign({}, pagination)
    });


    component.bus.$on('addToPayload', (payload = {}, formName = 'crud') => {
        addToPayload(component, payload, formName);
    });


    component.bus.$on('editCRUDItem', (index) => editItem(component, index));

    component.bus.$on('createItem', (isEmpty = true) => createItem(component, isEmpty));

    component.bus.$on('displayWhat', async(what, isSearch = false) => {
        displayWhat(component, what, isSearch);
    });

    component.bus.$on('closeForm', async(isSearch = false) => {
        closeForm(component, isSearch);
    });
    component.bus.$on('close', (isSearch = false) => closeForm(component, isSearch));

    component.bus.$on('closeSubForm', async(name) => {
        // console.log('closeSubForm', name);
        closeSubForm(component, name);
    });

    component.bus.$on('toggleAll', () => {
        toggleAll(component);
    });

    component.bus.$on('export2PDF', () => {
        let JSPDF = jsPDF;
        let doc = new JSPDF('landscape', 'pt', 'a4');
        // console.log(document.getElementById('grid_data').childNodes[0].childNodes[0]);
        doc.addHTML(document.getElementById('grid_data').childNodes[0].childNodes[0], function() {
            doc.save('MAP_' + component.entity + '_QuickReport_' + (new ObjectID()) + '.pdf');
        });

        /** pdf.html(document.body, {
          callback: function (pdf) {
            let iframe = document.createElement('iframe');
            iframe.setAttribute('style', 'position:absolute;right:0; top:0; bottom:0; height:100%; width:500px');
            document.body.appendChild(iframe);
            iframe.src = pdf.output('datauristring');
          }
        });  */
    });

    component.bus.$on('export2Excel', () => {
        let tab_text = '<table border="2px"><tr bgcolor="#87AFC6">';
        let textRange;
        let j = 0;
        let tab = document.getElementById('grid_data').childNodes[0].childNodes[0]; // id of table
        for (let j = 0; j < tab.rows.length; j++) {
            tab_text = tab_text + tab.rows[j].innerHTML + '</tr>';
            // tab_text=tab_text+"</tr>";
        }

        tab_text = tab_text + '</table>';
        tab_text = tab_text.replace(/<A[^>]*>|<\/A>/g, ''); // remove if u want links in your table
        tab_text = tab_text.replace(/<img[^>]*>/gi, ''); // remove if u want images in your table
        tab_text = tab_text.replace(/<input[^>]*>|<\/input>/gi, ''); // reomves input params
        tab_text = tab_text.replace(/<i[^>]*>|<\/i>/gi, ''); // reomves input params
        tab_text = tab_text.replace(/<div[^>]*>|<\/div>/gi, ''); // reomves input params
        tab_text = tab_text.replace(/check_box_outline_blank/gi, ''); // reomves input params
        tab_text = tab_text.replace(/arrow_upward/gi, ''); // reomves input params



        // let ua = window.navigator.userAgent;
        // let msie = ua.indexOf("MSIE "); 

        let sa = window.open('data:application/vnd.ms-excel,' + encodeURIComponent(tab_text)); // other browser not tested on IE 11


        return sa;
    });

    component.bus.$on('toggleOne', (item) => {
        toggleOne(component, item);
    });

    component.bus.$on('save', (isFormSimple) => save(component, isFormSimple));

    component.bus.$on('saveSubForm', async(name) => {
        let {
            data,
            error
        } = await saveSubForm(component, name);
        if (error) return;

        component.bus.$emit('closeSubForm', name);
    });
    component.bus.$on('uploadSubForm', async(name) => {
        let {
            data,
            error
        } = await saveSubForm(component, name, true);
        if (error) {
            Swal.fire({
                title: `<strong>Upload error</strong>`,
                type: 'error',
                html: error,
                showCloseButton: true,
                showCancelButton: false,
                focusConfirm: false,
                confirmButtonText: 'Close',
            });
            return;
        }

        component.bus.$emit('closeSubForm', name);
    });

    component.bus.$on('openSubForm', async(name) => {
        // console.log('openSubForm', name);
        component.bus.$emit('feedFieldsValues', name);
        component.bus.$emit('displayWhat', name);
    });

    component.bus.$on('editSubFormItem', (item, formName, index) => {
        editSubFormItem(component, item, formName, index);
    });

    component.bus.$on('previewSubFormItem', (item, formName, index) => {
        previewSubFormItem(component, item, formName, index);
    });

    component.bus.$on('previewUploadedFile', (item, formName, index) => {
        previewUploadedFile(component, item, formName, index);
    });

    component.bus.$on('deleteSubFormItem', (item, formName, index) => {
        Swal.fire({
            title: 'Delete item?',
            text: 'You won\'t be able to revert this!',
            type: 'error',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Delete it!',
            backdrop: `
          rgba(0,0,123,0.4)
          url("./static/nyan-cat.gif")
          center left
          no-repeat
        `
        }).then((result) => {
            if (result.value) {
                deleteSubFormItem(component, item, formName, index);
                Swal.fire(
                    'Deleted!',
                    'Now you need to save the main form to save the changes.',
                    'warning'
                );
            }
        });
    });

    component.bus.$on('clearFieldsValues', (formName) => {
        clearFieldsValues(component, formName);
    });

    component.bus.$on('feedFieldsValues', async(formName, isSearch = false) => {

        component.dialog_loading = true;
        component.loading = true;
        await feedFieldsValues(component, formName, isSearch);
        component.dialog_loading = false;
        component.loading = false;
    });

    component.bus.$on('deleteItem', async(item = false) => {
        Swal.fire({
            title: 'Delete item?',
            text: 'You will be able to restore this record anyway!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Delete it!',
            backdrop: `
          rgba(0,0,123,0.4)
          url("./static/nyan-cat.gif")
          center left
          no-repeat
        `
        }).then(async(result) => {
            if (result.value) {
                await deleteItem(component, item);
                Swal.fire(
                    'Deleted!',
                    'Your record has been deleted.',
                    'success'
                );
            }
        });
    });
    component.bus.$on('hardDeleteItem', async(item = false) => {
        Swal.fire({
            title: 'Delete item?',
            text: 'You won\'t be able to revert this!',
            type: 'error',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Delete it!',
            backdrop: `
          rgba(0,0,123,0.4)
          url("./static/nyan-cat.gif")
          center left
          no-repeat
        `
        }).then(async(result) => {
            if (result.value) {
                await deleteItem(component, item, 'hard');
                Swal.fire(
                    'Deleted!',
                    'Your record has been deleted.',
                    'success'
                );
            }
        });

    });
    component.bus.$on('restoreItem', async(item = false) => {
        Swal.fire({
            title: 'Restore item?',
            text: 'Are you sure you want to restore the selected items!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Restore it!',
            backdrop: `
          rgba(0,0,123,0.4)
          url("./static/nyan-cat.gif")
          center left
          no-repeat
        `
        }).then(async(result) => {
            if (result.value) {
                await restoreItem(component, item);
                Swal.fire(
                    'Restored!',
                    'The item has been restored.',
                    'warning'
                );
            }
        });
    });

    /** $and: [
          { $or: [
            {a: 1}, 
            {b: 1}
          ] }
        ] */
    component.bus.$on('doAdvancedSearch', (value) => {
        // console.log('XXXXXX----->>>>>>>>>>>>> doAdvancedSearch');
        let objValues = JSON.parse(JSON.stringify(component.form_search.user_values));
        let objOperators = JSON.parse(JSON.stringify(component.form_search.operators));
        let logicalOperator = '$' + component.form_search.matching_operator;
        let queryObj = {};
        let innerQuery = {};
        innerQuery[logicalOperator] = [];

        delete objValues._id;
        delete objOperators._id;

        for (let property in objValues) {
            if (objValues.hasOwnProperty(property)) {
                let objQuery = mountFieldQuery(objValues, objOperators, property, innerQuery, logicalOperator);
                innerQuery = objQuery.innerQuery;
            }
        }

        queryObj = {
            $and: [innerQuery]
        };
        clearFieldsValues(component, 'search');
        component.bus.$emit('displayWhat', 'grid');
        // console.log(queryObj);
        if (queryObj.$and[0]) {
            if (queryObj.$and[0][logicalOperator]) {
                if (queryObj.$and[0][logicalOperator].length > 0) {
                    // console.log(queryObj);
                    feedGrid(component, queryObj);
                    return;
                }
            }
        }

        feedGrid(component);

    });

    component.bus.$on('doTextSearch', (value) => {
        component.bus.$emit('displayWhat', 'grid');
        if (value === '' || value === null) {
            feedGrid(component);
        } else {
            feedGrid(component, {
                '$text': {
                    '$search': value
                }
            });
        }
    });
}

function addToPayload(component, payload, formName) {
    for (let field in payload) {
        Vue.set(component.forms[formName].user_values, field, payload[field]);
    }
};


export function addNewDocumentToVm(component, data) {
    component.selected = [];
    let newDocument = {};
    for (let prop in component.swagger.definitions[component.entity].properties) {
        if (component.swagger.definitions[component.entity].properties.hasOwnProperty(prop)) {
            let property = component.swagger.definitions[component.entity].properties[prop];
            if (property.type === 'string' || property.type === 'number') {
                newDocument[prop] = data[prop];
            }
        }
    }
    component.documents.unshift(mountDataForGridBasedOnSawgger(component.swagger, component.entity, component.headers, [data])[0]);
    component.original_documents.unshift(data);
};

export function updateDocumentOnVm(component, data, index) {
    /** component.selected = component.selected.filter(d => { 
      if (d._id === data._id)
      {
        return false;
      }
      else
      {
        return true;
      }
    }); */
    Object.assign(component.documents[index], mountDataForGridBasedOnSawgger(component.swagger, component.entity, component.headers, [data])[0]);
    Object.assign(component.original_documents[index], data);
};

export function deleteDocumentOnVm(component, data, index) {
    /** component.selected = component.selected.filter(d => { 
      if (d._id === data._id)
      {
        return false;
      }
      else
      {
        return true;
      }
    }); */
    component.selected = [];
    component.documents.splice(index, 1);
    component.original_documents.splice(index, 1);

};

/** export function getFormSubDocumentId (component, values, index) {
  if (index === -1) return 0;
  let document = values[index];
  // console.log(document);
  return document._id || false;
}; */

export function getDocumentById(component, _id = false) {
    let response = {
        document: false,
        index: -1
    };

    if (_id === false) return response;

    component.documents.forEach((d, index) => {
        if (d._id === _id) {
            response.document = d;
            response.index = index;
        }
    });
    return response;
};

export function feedGrid(component, where = false) {
    // console.log('xxxxxxxx------------> feedGrid ');
    component.where = where;

    (async() => {
        component.dialog_loading = true;
        component.loading = true;
        let {
            allData,
            data,
            total,
            error
        } = await getDataFromApi(component.entity, component, where);
        if (error) {
            console.error(error);
            return;
        }
        component.selected = [];
        component.original_documents = [];
        component.documents = [];
        component.original_documents = allData;
        // console.log(component.original_documents);
        component.totalDocuments = total;
        component.documents = mountDataForGridBasedOnSawgger(component.swagger, component.entity, component.headers, data);
        component.dialog_loading = false;
        component.loading = false;
    })();
};


export async function createSubRecordOnServer(component, entity, newRecord) {
    let errorMessage = false;
    let formatedRecord = mountPayloadBasedOnSwagger(component, entity, newRecord);
    // console.log('formatedRecord', formatedRecord);
    const {
        data,
        error
    } = await create(entity, formatedRecord);
    if (error) {
        errorMessage = error;
        if (error.message) errorMessage = error.message;
    }
    // console.log('reateSubRecordOnServer');
    // console.log(data, error);
    showSnack(component, errorMessage);
    return {
        data,
        error
    };
};

export async function createSubRecord(component, formName, parentField, newRecord) {
    console.log('createSubRecord', formName);
    console.log('parentField', parentField);
    console.log('newRecord', newRecord);
    let oldArray = [...(component.forms.crud.user_values[formName] || [])];
    let _data = null;
    let _error = null;
    if (parentField.$collection) {
        // save on server
        const entity = parentField.$collection.collection;
        let {
            data,
            error
        } = await createSubRecordOnServer(component, entity, newRecord);
        if (error) {
            _error = error;
        } else {
            newRecord = data;
            if (parentField.$collection.labelKey && parentField.$collection.valueKey) {
                newRecord = {};
                let keys = parentField.$collection.labelKey.split(',');
                let text = '';
                keys.forEach(k => {
                    text += ' ' + data[k.toString().trim()].toString().trim()
                });
                newRecord.text = text.toString().trim();
                newRecord.value = data[parentField.$collection.valueKey];
            }
            oldArray.push(newRecord);
            if (!component.original_documents[component.forms.crud.editedIndex]) {
                component.original_documents[component.forms.crud.editedIndex] = {}
            }
            Vue.set(component.original_documents[component.forms.crud.editedIndex], formName, []);
            Vue.set(component.original_documents[component.forms.crud.editedIndex], formName, oldArray);

            _data = newRecord;
        }
    } else {
        const _id = new ObjectID();
        newRecord._id = _id.toString();
        oldArray.push(newRecord);
        if (!component.original_documents[component.forms.crud.editedIndex]) {
            component.original_documents[component.forms.crud.editedIndex] = {}
        }
        Vue.set(component.original_documents[component.forms.crud.editedIndex], formName, []);
        Vue.set(component.original_documents[component.forms.crud.editedIndex], formName, oldArray);

        _data = newRecord;

        showSnack(component);
    }

    return {
        $data: _data,
        $error: _error
    };
};

export async function updateSubRecord(component, formName, parentField, newRecord, parentFormEditedIndex) {
    let oldArray = [...component.forms.crud.user_values[formName]];
    // console.log('updateSubRecord oldArray', oldArray);
    let _data = null;
    let _error = null;
    if (parentField.$collection) {
        // save on server

    } else {

        oldArray.splice(parentFormEditedIndex, 1);
        oldArray.push(newRecord);
        Vue.set(component.original_documents[component.forms.crud.editedIndex], formName, []);
        Vue.set(component.original_documents[component.forms.crud.editedIndex], formName, oldArray);
        _data = newRecord;

        showSnack(component);
    }
    return {
        $data: _data,
        $error: _error
    };
};

export async function uploadFile(url, newFile, type, params = {}) {

    let fileIsOk = true;
    let response = {};
    let formData = new FormData();

    if (Array.isArray(newFile)) {
        for (let i = 0; i < newFile.length; i++) {
            formData.append('file' + (i + 1), newFile[i]);
        }
    } else {
        formData.append('file', newFile);
    }

    for (let key in params) {
        formData.append(key, params[key]);
    }
    if (fileIsOk) {
        let request = await session.upload({
            data: formData,
            url: url,
            type: type,
            bus: window.getApp
        })

        response = {
            $data: request.data,
            $error: request.error
        }
    } else {
        response = {
            $data: false,
            $error: 'No file provided'
        }
    }
    return response;
};

export async function persistSubForm(component, formName, parentField, vmForm, isUpload) {
    // console.log('persistSubForm');
    const parentFormEditedIndex = vmForm.editedIndex;
    // console.log('vmForm.editedIndex', vmForm.editedIndex);
    let newRecord = JSON.parse(JSON.stringify(vmForm.user_values));
    let response = {};
    if (isUpload) {
        response = await uploadFile(component, formName, parentField, newRecord, parentFormEditedIndex);
    } else {
        if (parentFormEditedIndex === -1) {
            response = await createSubRecord(component, formName, parentField, newRecord);
            // console.log('createSubRecord', response);
        } else // update
        {
            response = await updateSubRecord(component, formName, parentField, newRecord, parentFormEditedIndex);
            // console.log('updateSubRecord', response);
        }
    }

    return response;
};

export async function saveSubForm(component, formName, isUpload = false) {
    const vForm = component.$refs.xForm.$refs['form_' + formName][0];
    const vmForm = component.forms[formName];
    const parentField = component.forms.crud.fields.filter(field => {
        return field.id === formName
    })[0];
    if (!vForm.validate()) {
        showSnack(component, 'Please check the form');
        return {
            data: [],
            error: 'Please check the form'
        };
    }
    let {
        $error,
        $data
    } = await persistSubForm(component, formName, parentField, vmForm, isUpload);
    // console.log('saveSubForm');
    // console.log($error, $data);
    return {
        data: $data,
        error: $error
    };
};



export async function setFieldOptions(component, field, formName) {
    // console.log('setFieldOptions');
    // console.log(field, formName);
    let {
        error,
        data
    } = await getLocalCollection(field.collection.collection);
    data = data.map(doc => {
        let keys = field.collection.labelKey.split(',');
        let text = '';
        keys.forEach(k => {
            text += ' ' + doc[k.toString().trim()].toString().trim()
        });
        return {
            text: text,
            value: doc[field.collection.valueKey]
        };
    });
    if (error) {
        console.error(error);
        Vue.set(component.forms[formName].values, field.id, []);
    } else {
        Vue.set(component.forms[formName].values, field.id, data);
    }
};

export async function setFieldGridValues(component, field, formName) {
    // console.log('------->>>> START setFieldGridValues');
    //if (component.forms.crud.editedIndex > -1) {

    let refArray = field.$schema.properties[field.id].items.$ref.split('/');
    // sub document schema name
    let schemaName = refArray[refArray.length - 1];
    let subFieldDefinition = component.swagger.definitions[schemaName];
    // console.log(field, formName);
    // console.log(field.$schema.properties[field.id].items.$ref);
    // console.log(field.id);
    // console.log(component.forms.crud.editedIndex);


    // if is creating a new record, then it doesnt exists in original_documents array
    if (!component.original_documents[component.forms.crud.editedIndex]) {
        console.warn(`component.original_documents[${component.forms.crud.editedIndex}] does not exist, creating it`);
        component.original_documents[component.forms.crud.editedIndex] = {}
    }
    if (!component.original_documents[component.forms.crud.editedIndex][field.id]) {
        console.warn(`component.original_documents[${component.forms.crud.editedIndex}][${field.id}] does not exist, creating it`);
        component.original_documents[component.forms.crud.editedIndex][field.id] = [];
    }

    // console.log(component.original_documents[component.forms.crud.editedIndex]);
    // console.log(component.original_documents[component.forms.crud.editedIndex][field.id]);

    const fieldRecords = JSON.parse(JSON.stringify(component.original_documents[component.forms.crud.editedIndex][field.id]));
    // console.info('fieldRecords', fieldRecords);

    let fieldHeaders = component.forms[formName].headers[field.id];
    // console.info('grid headers', fieldRecords);
    // console.info('grid rows', mountDataForGrid(fieldHeaders, fieldRecords));
    Vue.set(component.forms[formName].values, field.id, mountDataForGrid(fieldHeaders, fieldRecords));

    let data_labels = await mountLabelsForGrid(subFieldDefinition, fieldHeaders, fieldRecords);
    // console.log('data_labels', data_labels);
    // console.log(field.id, field);
    if (data_labels.length > 0) {
        Vue.set(component.forms[formName].labels, field.id, data_labels);
    }

    // console.log(component.forms[formName].values[field.id]);
    //} else {
    //  Vue.set(component.forms[formName].values, field.id, []);
    //}

    // console.log('------->>>> END setFieldGridValues');
};

// set the values of a field
export async function feedFieldValues(component, field, formName, isSearch) {

    // console.log('formName', formName);
    // console.log(field, field.id + ' ' + field.type);
    if (field.collection) {
        await setFieldOptions(component, field, formName);
    }

    if (field.type === 'grid') {
        await setFieldGridValues(component, field, formName);
    } else if (field.type === 'date' || field.type === 'date-time') {
        // console.log('CCCCCCCCCCC', field);
        component.bus.$emit('mountPicker', field, (formName === 'crud' ? component.entity : formName), component.forms[formName].user_values, isSearch);
    } else if (field.type === 'base64') {
        if (component.forms[formName].user_values[field.id] === '' || component.forms[formName].user_values[field.id] === null) {
            component.forms[formName].user_values[field.id] = '/static/avatar.png';
        }
    } else {
        if (component.forms[formName].user_values[field.id] === '' || component.forms[formName].user_values[field.id] === null) {
            // component.swagger.definitions[component.entity].properties
            // getFormDefault()

            if (typeof field.defaultValue !== 'undefined') component.forms[formName].user_values[field.id] = field.defaultValue;
        }
    }
    // if is a schema
};

// reads all fields and set it values
export async function feedFieldsValues(component, formName, isSearch = false) {
    for (let x = 0; x < component.forms[formName].fields.length; x++) {
        let field = component.forms[formName].fields[x];
        await feedFieldValues(component, field, formName, isSearch);
    }
};


export function clearFieldValues(component, field, formName) {
    let vmForm = component.form_search;
    if (formName !== 'search') {
        vmForm = component.forms[formName];
    }

    if (field.type === 'date' || field.type === 'date-time') {
        //   flatpickr(`#${field.id}`, {});
        component.bus.$emit('clearPicker', field, formName);
        vmForm.user_values[field.id] = null;
    } else {
        // vmForm.user_values[field.id] = '';
    }
};

export function clearFieldsValues(component, formName) {
    let vmForm = component.form_search;
    if (formName !== 'search') {
        vmForm = component.forms[formName];
    }
    for (let x = 0; x < vmForm.fields.length; x++) {
        let field = vmForm.fields[x];
        clearFieldValues(component, field, formName);
    }
};


export function readPhotoFile(component, fileId, base64) {
    // console.log(fileId, base64);
    component.forms.crud.user_values[fileId] = base64;
};
export function showSnack(component, errorMessage = false, message = 'Data saved') {
    console.log('XXXXX SHOW SNACK')
    component.snack = true;
    component.snackColor = errorMessage ? 'error' : 'success';
    component.snackText = errorMessage ? errorMessage : message;
};
export function toggleAll(component) {
    if (component.selected.length) {
        component.selected = [];
    } else {
        component.selected = component.documents.slice();
    }
};
export function toggleOne(component, item) {
    // console.log(item);
    // console.log(component.selected.indexOf(item));
    if (component.selected.indexOf(item) > -1) {
        component.selected.splice(component.selected.indexOf(item), 1);
    } else {
        component.selected.push(item);
    }
};

export function sortList(entity, items, parentEntity = 'Account', parentId = 'Me', sortArray) {
    const itemKey = entity.toLowerCase();
    if (typeof sortArray === 'undefined') {
        const parentCollection = store.state[parentEntity];
        const parentItem = parentId && Array.isArray(parentCollection) ? parentCollection.find(item => item.id === parentId) : parentCollection;
        sortArray = parentItem[itemKey] || [];
    }
    return items.sort(function(a, b) {
        const indexA = sortArray.findIndex(item => item[itemKey] === a.id);
        const indexB = sortArray.findIndex(item => item[itemKey] === b.id);
        const sortA = indexA > -1 ? sortArray[indexA].sort_no : 0;
        const sortB = indexB > -1 ? sortArray[indexB].sort_no : 0;
        return sortA - sortB;
    });
};

export async function updateSortList(entity, items, parentEntity = 'Account', parentId = 'Me', parentItem) {
    const itemKey = entity.toLowerCase();
    const sortArray = items.map((item, index) => {
        return {
            [itemKey]: item.id,
            sort_no: index + 1
        };
    });
    if (typeof parentItem === 'undefined') {
        const parentCollection = store.state[parentEntity];
        if (parentId && Array.isArray(parentCollection)) {
            const pItemIndex = parentCollection.findIndex(item => item.id === parentId);
            parentItem = {...parentCollection[pItemIndex]
            };
            parentItem[itemKey] = sortArray;
            store.state[parentEntity][pItemIndex] = {...parentItem
            };
        } else {
            parentItem = {...parentCollection
            };
            parentItem[itemKey] = sortArray;
            store.state[parentEntity] = {...parentItem
            };
        }
    } else {
        parentItem[itemKey] = sortArray;
    }
    if (parentEntity === 'Account') {
        parentItem.updated_from = 'default';
        if (parentItem.agency) {
            delete parentItem.agency;
        }
    }
    if (parentEntity === 'Agency' && parentItem.account) {
        delete parentItem.account;
    }
    let {
        error,
        data,
        status
    } = await update(parentEntity, parentItem, parentId);
};

export function formatDate(dateString, format = 'MM/DD/YYYY') {
    if (dateString) {
        try {
            return moment(dateString).utc().format(format);
        } catch (e) {
            return dateString
        }
    }
};

export function validateUrl(url) {
    if (url && typeof url !== 'undefined') {
        return /^(?:(?:(?:https?|ftp):)?\/\/)?(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(url);

    }
    return false;
};

export function isEmailValid(email) {
    if (email) {
        return /^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4},?)+$/.test(email);
    }
    return false;
}

export function isPhoneValid(phone) {
    if (phone) {
        return /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/.test(phone)
    }
    return false;
}

export function getCardType(cardNumber) {
    /* Visa */
    let re = new RegExp("^4[0-9]{6,}$");
    if (cardNumber.match(re)) {
        return "Visa";
    }
    /* Mastercard */
    re = new RegExp("^5[1-5][0-9]{5,}|222[1-9][0-9]{3,}|22[3-9][0-9]{4,}|2[3-6][0-9]{5,}|27[01][0-9]{4,}|2720[0-9]{3,}$");
    if (cardNumber.match(re)) {
        return "Mastercard";
    }
    /* American Express */
    re = new RegExp("^3[47][0-9]{5,}$");
    if (cardNumber.match(re)) {
        return "American Express";
    }
    /* Diners Club */
    re = new RegExp("^3(?:0[0-5]|[68][0-9])[0-9]{4,}$");
    if (cardNumber.match(re)) {
        return "Diners Club";
    }
    /* Discover */
    re = new RegExp("^6(?:011|5[0-9]{2})[0-9]{3,}$");
    if (cardNumber.match(re)) {
        return "Discover";
    }
    /* JCB */
    re = new RegExp("^(?:2131|1800|35[0-9]{3})[0-9]{3,}$");
    if (cardNumber.match(re)) {
        return "JCB";
    }
    /* Union Pay */
    re = new RegExp("^(62|88)\d+$");
    if (cardNumber.match(re)) {
        return "Union Pay";
    }

    return null;

};

export async function WPAPILogin() {

    let url = config.WPParams.api.url + 'jwt-auth/v1/token';
    let payload = {
        username: config.WPParams.api.user,
        password: config.WPParams.api.password
    };
    let response = await session.WPAPILogin({
        url: url,
        method: 'POST',
        payload: payload
    });
    return response;
}

export async function guestLogin() {

    try {
        if (store.state.GuestToken) {
            return true;
        }
        window.getApp.$emit('LoadingText', 'Authenticating the server');
        const guestLoginRes = await session.loginPromise({
            username: config.WPParams.api.user,
            password: config.WPParams.api.password,
            loginUserRole: 'guest'
        });
        if (guestLoginRes && guestLoginRes.token) {
            store.commit('setGuestToken', guestLoginRes.token);
            return true;
        }
    } catch (e) {
        return false;
    }
    return false;
}

export async function requestToWPPF(url, method, payload = {}) {

    let response = await session.requestToWPPF({
        url: url,
        method: method,
        payload: payload

    });
    return response;

}

export async function checkWPToken() {

    if (session.getWPSession()) {
        return true;
    }
    let response = await WPAPILogin();
    if (!response.success) {
        Swal.fire({
            title: `<strong>Connection Error</strong>`,
            type: 'error',
            html: 'Failed to connect with WP API, Refresh the page and try again',
            showCloseButton: true,
            showCancelButton: false,
            focusConfirm: false,
            confirmButtonText: 'Close'
        });
        return false;
    } else {
        return true;
    }

}

export function stringToSlug(str) {

    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();

    // remove accents, swap Ã± for n, etc
    let from = "Ã Ã¡Ã¤Ã¢Ã¨Ã©Ã«ÃªÃ¬Ã­Ã¯Ã®Ã²Ã³Ã¶Ã´Ã¹ÃºÃ¼Ã»Ã±Ã§Ä›Å¡ÄÅ™Å¾Ã½ÃºÅ¯ÄÅ¥ÅˆÂ·/_,:;";
    let to = "aaaaeeeeiiiioooouuuuncescrzyuudtn------";

    for (let i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace('.', '-') // replace a dot by a dash 
        .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by a dash
        .replace(/-+/g, '-') // collapse dashes
        .replace(/\//g, ''); // collapse all forward-slashes

    return str;

}

export async function request(collection, method, payload = {}, populate = null, where = null, isGuest = false) {
    if (isGuest && !store.state.GuestToken) {
        return { error: 'Guest not logged in' };
    }
    collection = collection.replace(/ /gi, '');
    let error = false;
    let data = false;
    let count = 0;
    let url = collection
    if (method !== 'GET') {
        payload = JSON.stringify(payload);
    } else {
        let queryString = '';
        if (populate) {
            queryString = populate ? 'populate=' + (typeof populate === 'string' ? populate : JSON.stringify(populate)) : '';
        }
        if (where) {
            queryString += !where ? '' : '&where=' + JSON.stringify(where);
        }
        if (queryString) {
            url += `?${queryString}`;            
        }
    }
    let response = await session.http({
        url: `${url}`,
        type: method,
        data: payload,
        token: isGuest ? store.state.GuestToken : null
    });
    error = response.error;
    data = response.data;
    count = response.count || 0;
    return {
        error,
        data,
        count
    };
}

export async function requestExternal(url, method, params = {}, payload = {}, responseType = null) {
    let error = false;
    let data = false;
    payload = JSON.stringify(payload);
    let axiosObj = {
        method: method,
        url: url,
        data: payload
    };
    if (responseType) {
        axiosObj.responseType = responseType;
    }
    let response = await axios(axiosObj);
    error = response.error;
    data = response.data;
    return {
        error,
        data
    };
}

export async function conversationListPopulate(human) {

    if (!human || !human.trim()) {
        return ''
    }
    
    return [
      {
        path: 'last_message',
        populate: {
          path: 'human',
          select: 'account agency user',
          populate: [
            { path: 'agency', select: 'name avatar' },
            { path: 'account', select: 'name avatar' }
          ]
        }
      },
      {
        path: 'message.message',
        populate: {
          path: 'human',
          select: 'account agency user',
          populate: [
            { path: 'agency', select: 'name avatar' },
            { path: 'account', select: 'name avatar' }
          ]
        },
        match: { 'removed': { $ne: human } }
      },
      {
        path: 'human', populate: [
          { path: 'user', select: 'roles'},
          { path: 'account', select: 'name'},
          { path: 'agency', select: 'name'},
        ]
      },
      {
        path: 'groups', select: 'name'
      }
    ]
}

export async function conversationSinglePopulate(human) {

    if (!human || !human.trim()) {
        return ''
    }

    return [
        'last_message',
        {
            path: 'message.message',
            match: { 'removed': { $ne: human } }
        },
        {
            path: 'human',
            populate: [
                { path: 'user', select: 'roles'},
                { path: 'account', select: 'name contactInfo avatar'},
                { path: 'agency', select: 'name email avatar'},
            ]
        }
    ]
}

export async function getVimeoJSON (videoID) {
    try {
        let error = null
        let data = null
        let response = await axios({
            method: 'GET',
            url: `https://vimeo.com/api/v2/video/${videoID}.json`
        });
        error = response.error;
        data = response.data;
        return {
            error,
            data
        };
    } catch (e) {
        error = e;
        return {
            error,
            data
        };
    }
}

export function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
}

export function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function isYouTubeVideo(link) {
    // YouTube URL pattern
    var youtubePattern = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\//;
    
    // Match the link against the pattern
    var match = link.match(youtubePattern);
    
    // If the match is found, it's a YouTube video
    return match !== null;
}

export function checkIfNoPFUrl (url) {
    if (url) {
      return url.indexOf('/profile/') === -1/*  && url.split('/').length <= 3 */;
    }
    return false;
}

export function mergeObjects(target, source) {
    for (const key in source) {
        if (source.hasOwnProperty(key)) {
            if (typeof source[key] === 'object' && !Array.isArray(source[key])) {
                if (!target.hasOwnProperty(key)) {
                    target[key] = {};
                }
                mergeObjects(target[key], source[key]);
            } else if (!target.hasOwnProperty(key)) {
                target[key] = source[key];
            }
        }
    }
    return target;
}

export function formatPrice (value) {
    if (typeof value !== 'undefined') {
      let val = Number(parseFloat(value, 10).toFixed(2)).toLocaleString();
      return '$ ' + (val.indexOf('.') > -1 ? val : (val + '.00'));
    }
    return 'Not found';
}

export function formatFileSize(bytes) {
    if (!bytes) {
        return null;
    }
    if (bytes < 1024) {
        return bytes + ' B';
    } else if (bytes < 1024 * 1024) {
        return (bytes / 1024).toFixed(2) + ' KB';
    } else if (bytes < 1024 * 1024 * 1024) {
        return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
    } else {
        return (bytes / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
    }
}

export function getFileExtension (url) {
    if (!url) {
        return null;
    }
    // Get the last part of the URL after the last dot
    const parts = url.split('.');
    const lastPart = parts[parts.length - 1];
    
    // Extract the file extension (assuming it doesn't contain any query parameters)
    const extension = lastPart.split('?')[0];
    
    return extension;
}

export function isObjectEmpty (obj) {
    return !obj || !Object.keys(obj).filter(key => obj[key].length).length 
}

export function calculateAge(birthDate) {
    try {
        const today = new Date();
        const birth = new Date(birthDate);
        let age = today.getFullYear() - birth.getFullYear();
        const monthDiff = today.getMonth() - birth.getMonth();
    
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
            age--;
        }
        return Math.floor(age);
    } catch (e) {
        return ''
    }

}

export async function imageUrlToBase64(url) {
    try {
        const response = await request(`Photo/Proxy?url=${url}`, 'GET');
        return response.data || '';
    } catch (e) {
        return ''
    }
}

export async function imageURLToBase64Direct(url) {
    try {
        const response = await axios({
            method: 'GET',
            url: url,
            responseType: 'arraybuffer'
        });
        const base64 = Buffer.from(response.data, 'binary').toString('base64');
        return `data:${response.headers['content-type']};base64,${base64}`;
    } catch (e) {
        throw e;
    }
}


// WEBPACK FOOTER //
// ./src/helpers/helpers.js